define("media/routes/application", ["exports", "@ember/routing/route", "@ember/service", "later/utils/constants"], function (_exports, _route, _service, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
  0; //eaimeta@70e063a35619d71f0,"@ember/routing/route",0,"@ember/service",0,"later/utils/constants"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  let ApplicationRoute = _exports.default = (_class = class ApplicationRoute extends _route.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "mediaItemQuery", _descriptor2, this);
      _initializerDefineProperty(this, "mediaNavigation", _descriptor3, this);
      _initializerDefineProperty(this, "queryPersistence", _descriptor4, this);
      _initializerDefineProperty(this, "router", _descriptor5, this);
      _initializerDefineProperty(this, "segment", _descriptor6, this);
      _initializerDefineProperty(this, "starredMedia", _descriptor7, this);
      _initializerDefineProperty(this, "store", _descriptor8, this);
    }
    activate() {
      this.segment.track('viewed-page', {
        page: 'media-library'
      });
    }
    beforeModel() {
      if (this.currentGroup?.contributor) {
        this.router.transitionTo('cluster.collect.contribute');
      } else {
        this.queryPersistence.updateGroup('media-library', this.currentGroup?.id);
      }
    }
    async model() {
      await this.starredMedia.initStarredMedia();
      return new Promise((resolve, reject) => {
        const params = {
          groupId: this.currentGroup?.id,
          labelIds: this.queryPersistence.getLabelIds('media-library', ''),
          dateFilter: this.queryPersistence.getDateFilter('media-library', 'all'),
          usedUnused: this.queryPersistence.getUsedUnused('media-library', ''),
          mediaTypeFilter: this.queryPersistence.getMediaTypeFilter('media-library', ''),
          searchString: this.queryPersistence.getSearchString('media-library', ''),
          socialProfileIds: this.queryPersistence.getSocialProfileIds('media-library', ''),
          trackEvent: false,
          limit: _constants.MEDIA_ITEMS_LIMIT,
          successCallback: resolve,
          failureCallback: reject
        };
        this.mediaItemQuery.queryWithFilters(params);
      }).catch(); // error handling needs to be improved with errors services when the logging issue is fixed
    }
    setupController(controller) {
      controller.set('allMediaItems', this.store.peekAll('media-item'));
      this.mediaNavigation.setNarrowArrows(true);
    }
    deactivate() {
      this.controller.set('showingTableView', false);
      this.mediaNavigation.setNarrowArrows(false);
      this.mediaNavigation.clearMediaItems();
    }
    get currentGroup() {
      return this.auth.currentGroup;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "mediaItemQuery", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "mediaNavigation", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "queryPersistence", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "starredMedia", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
});